<template>
    <div id="menu-create-group" class="w-100">
        <link rel="stylesheet" href="https://fonts.googleapis.com/css2?family=Material+Symbols" />
        <div class="header w-100 d-flex align-items-center justify-content-between">
            <div class="back-button" @click="backButton()">
                <span class="material-symbols-outlined">
                    arrow_back
                </span>
            </div>

            <div v-if="title.length" class="title">
                <span>{{ title }}</span>
            </div>

            <div class="hamburguer-menu">

                <div ref="actions_dropdown" class="ui right pointing suidropdown icon">
                    <span class="material-symbols-outlined">
                        more_vert
                    </span>
                    <div class="menu">
                        <div class="item d-flex align-items-center gap-3" @click="groupDetails()">
                            <!-- <span class="material-symbols-outlined">
                                more_horiz
                            </span> -->
                            {{ $i18n.t('notification.group.group_edit') }}
                        </div>
                        <div v-if="!isGroupOwner" class="item d-flex align-items-center gap-3" @click="exitGroup()">
                            <span class="material-symbols-outlined">
                                group_remove
                            </span>
                            {{ $i18n.t('notification.exit_group') }}
                        </div>
                    </div>
                </div>


            </div>

        </div>

        <div id="group-info" class="tab active" data-tab="group-info">
            <div class="d-flex flex-column">

                <div class="upload-group-img d-flex w-100 justify-content-center py-24">

                    <div class="group-image">

                        <div class="thumb-icon d-flex justify-content-center align-items-center">
                            <div v-if="data.thumbnail" class="thumb-container">
                                <div class="thumb" :style="`background: url(${data.thumbnail});`">
                                </div>
                            </div>
                            <div v-else>
                                <span  class="material-symbols-outlined landscape-icon">
                                    landscape
                                </span>
                                <!--<div class="upload d-flex align-items-center justify-content-center">
                                    <span class="material-symbols-outlined upload-icon">
                                        upload
                                    </span>
                                </div>-->
                            </div>
                        </div>


                    </div>
                </div>

                <div class="label-create-group d-flex justify-content-center">
                    <span>{{ data.name }}</span>
                </div>
                <div class="label-description-group d-flex justify-content-between mt-2 gap-1">
                    <span class="description">
                        {{ data.description }}
                        <span class="see-less" @click="openDescription()">{{  $t('notification.see_less') }}</span>
                    </span>
                    <span class="see-more" @click="openDescription()">{{  $t('notification.see_more') }}</span>

                </div>


                <div class="group-members d-flex flex-column">

                    <div class="search-add d-flex align-items-center justify-content-between gap-3 py-3">
                        <div class="ui icon input flex-grow-1">
                            <input type="text" :placeholder="$t('notification.group.search')" @input="handleSearchUserInput" v-model="searchUserInput">
                            <span class="material-symbols-outlined search-icon" @click="handleSearchUserInput">
                            search
                        </span>
                        </div>
                    </div>

                    <div class="users-count d-flex justify-content-between align-items-center">
                        <div class="d-flex gap-1">
                            <span>{{ listUsersFiltered.length }}</span>
                            <span>{{ $tc('notification.members', listUsersFiltered.length)}}</span>
                        </div>
                        <span class="see-all-users" @click="seeAllGroupMembers()">{{ $t('notification.see_all')}}</span>
                    </div>

                    <div class="list-users">

                        <template v-if="listUsersFiltered.length">
                            <div class="user d-flex align-items-center justify-content-between py-2" v-for="user in listUsersFiltered.slice(0, 4)" :key="user.id">
                                <div class="d-flex align-items-center gap-3">
                                    <div class="thumb-container">
                                        <div class="thumb" :style="`background: url(${user.avatar});`">
                                        </div>
                                    </div>
                                    <span>{{ user.name }}</span>
                                </div>

                                <div>
                                    <div v-if="user.id !== id" ref="actions_dropdown_user" class="ui right pointing suidropdown icon actions_user">
                                        <span class="material-symbols-outlined">
                                            more_vert
                                        </span>
                                        <div v-if="!showReportOptions" class="menu">
                                            <div class="item d-flex align-items-center gap-3" @click="addFriend(user.id)">
                                                <span class="material-symbols-outlined">
                                                    person_add
                                                </span>
                                                {{ $i18n.t('notification.add_friend') }}
                                            </div>
                                            <div class="item d-flex align-items-center gap-3" @click.stop="openReportReasons(user.id)">
                                                <span class="material-symbols-outlined">
                                                    flag
                                                </span>
                                                {{ $i18n.t('notification.report_user') }}
                                            </div>
                                            <div class="item d-flex align-items-center gap-3" @click="blockFriend(user.id)">
                                                <span class="material-symbols-outlined">
                                                    block
                                                </span>
                                                {{ $i18n.t('notification.block_user') }}
                                            </div>
                                        </div>

                                        <div v-else class="menu">

                                            <div v-if="user.id === selectedUserId" class="ui form">
                                                <div class="inline field">
                                                    <div class="ui radio checkbox">
                                                        <input type="radio" tabindex="0" name="report_reason"
                                                               :id="$i18n.t('notification.inappropriate_language_or_content')"
                                                               :value="$i18n.t('notification.inappropriate_language_or_content')"
                                                               v-model="iptReportReason">
                                                        <label>{{ $i18n.t('notification.inappropriate_language_or_content') }}</label>
                                                    </div>
                                                </div>
                                                <div class="inline field">
                                                    <div class="ui radio checkbox">
                                                        <input type="radio" tabindex="0" name="report_reason"
                                                               :id="$i18n.t('notification.hate_messages_offensive')"
                                                               :value="$i18n.t('notification.hate_messages_offensive')"
                                                               v-model="iptReportReason">
                                                        <label>{{ $i18n.t('notification.hate_messages_offensive') }}</label>
                                                    </div>
                                                </div>
                                                <div class="inline field">
                                                    <div class="ui radio checkbox">
                                                        <input type="radio" tabindex="0" name="report_reason"
                                                               :id="$i18n.t('notification.spam')"
                                                               :value="$i18n.t('notification.spam')"
                                                               v-model="iptReportReason">
                                                        <label>{{ $i18n.t('notification.spam') }}</label>
                                                    </div>
                                                </div>
                                                <div class="inline field">
                                                    <div class="ui radio checkbox">
                                                        <input type="radio" tabindex="0" name="report_reason"
                                                               :id="$i18n.t('notification.fake_account')"
                                                               :value="$i18n.t('notification.fake_account')"
                                                               v-model="iptReportReason">
                                                        <label>{{ $i18n.t('notification.fake_account') }}</label>
                                                    </div>
                                                </div>
                                                <div class="inline field">
                                                    <div class="ui radio checkbox">
                                                        <input type="radio" tabindex="0" name="report_reason"
                                                               :id="$i18n.t('notification.other')"
                                                               :value="$i18n.t('notification.other')"
                                                               v-model="iptReportReason">
                                                        <label>{{ $i18n.t('notification.other') }}</label>
                                                    </div>
                                                </div>
                                                <div class="inline field">

                                                    <input type="text"
                                                           maxlength="255"
                                                           :placeholder="$i18n.t('notification.other_reason')"
                                                           v-model="iptReportOtherReason"
                                                           :disabled="iptReportReason !== $i18n.t('notification.other')">

                                                </div>

                                                <div class="inline field">
                                                    <div class="ui button send-button" @click="reportReason()">
                                                        <span>{{ $i18n.t('notification.send') }}</span>
                                                    </div>
                                                </div>

                                            </div>

                                        </div>

                                    </div>
                                </div>
                            </div>
                        </template>
                        <template v-else>
                            <div class="h-100 d-flex flex-column justify-content-center align-items-center gap-2">
                                <span class="material-symbols-outlined search-icon">
                                    search_off
                                </span>
                                <span class="no-results">{{ $t('notification.group.no_results') }}</span>
                                <span class="no-user-found">{{ $t('notification.group.no_user_found') }}</span>
                            </div>
                        </template>

                    </div>

                </div>



                <div class="footer">

                <div class="ui divider"></div>

                <div class="btn-actions d-flex align-items-center gap-2">

                    <div v-if="isGroupOwner" class="btn-delete-group d-flex gap-1 aligns-items-center" @click="deleteGroup()">
                        <span class="material-symbols-outlined logout-icon">
                            delete
                        </span>
                        <div class="btn-cancel">
                            <span>{{ $t('notification.delete_group') }}</span>
                        </div>
                    </div>

                    <div v-else class="btn-exit-group d-flex gap-1 aligns-items-center" @click="exitGroup()">
                        <span class="material-symbols-outlined logout-icon">
                            logout
                        </span>
                        <div class="btn-cancel">
                            <span>{{ $t('notification.exit_group') }}</span>
                        </div>
                    </div>
                </div>
            </div>
            </div>
        </div>

        <div id="add-members" class="tab" data-tab="add-members">

            <div class="search-add d-flex align-items-center justify-content-between gap-3 py-3">
                <div class="ui icon input flex-grow-1">
                    <input type="text" :placeholder="$t('notification.group.search')" @input="handleSearchUserInput" v-model="searchUserInput">
                    <span class="material-symbols-outlined search-icon">
                        search
                    </span>
                </div>
            </div>

            <div class="list-users">
                
                <template v-if="listUsersFiltered.length">
                    <div class="user d-flex align-items-center justify-content-between py-2" v-for="user in listUsersFiltered" :key="user.id">
                        <div class="d-flex align-items-center gap-3">
                            <div class="thumb-container">
                                <div class="thumb" :style="`background: url(${user.thumb});`">
                                </div>
                            </div>
                            <span>{{ user.name }}</span>
                        </div>
                        <div v-if="user.selected" class="add-user" @click="toggleUserSelection(user)">
                            <div class="d-flex align-items-center justify-content-center align-items-center gap-2">
                                <span class="material-symbols-outlined person-add-icon">
                                    person_add
                                </span>
                                <span class="label">Adicionar</span>
                            </div>
                        </div>
                        <div v-else class="remove-user" @click="toggleUserSelection(user)">
                            <div class="d-flex align-items-center justify-content-center align-items-center gap-2">
                                <span class="material-symbols-outlined person-remove-icon">
                                    person_remove
                                </span>
                                <span class="label">{{ $t('notification.group.remove') }}</span>
                            </div>
                        </div>

                    </div>
                </template>
                <template v-else>
                    <div class="h-100 d-flex flex-column justify-content-center align-items-center gap-2">
                        <span class="material-symbols-outlined search-icon">
                            search_off
                        </span>
                        <span class="no-results">{{ $t('notification.group.no_results') }}</span>
                        <span class="no-user-found">{{ $t('notification.group.no_user_found') }}</span>
                    </div>
                </template>

            </div>

            <div class="save-members d-flex justify-content-center py-3">
                <div class="btn-save text-center">
                    <span>{{ $t('notification.group.save') }}</span>
                </div>
            </div>

        </div>

        <div id="all-group-users" class="tab py-24" data-tab="all-group-users">
            
            <div class="group-members d-flex flex-column">

                <div class="users-count d-flex justify-content-between align-items-center">
                    <div class="d-flex gap-1">
                        <span>{{ listUsersFiltered.length }}</span>
                        <span>{{ $tc('notification.members', listUsersFiltered.length)}}</span>
                    </div>
                </div>

                <div class="list-users">

                    <div class="user d-flex align-items-center justify-content-between py-2" v-for="user in listUsersFiltered" :key="user.id">
                        <div class="d-flex align-items-center gap-3">
                            <div class="thumb-container">
                                <div class="thumb" :style="`background: url(${user.avatar});`">
                                </div>
                            </div>
                            <span>{{ user.name }}</span>
                        </div>

                        <div class="d-flex">
                            <template v-if="user.id !== id">
                                <div v-if="isGroupOwner">
                                    <div class="ui button basic remove-group" @click="removeUserFromGroup(user.id)">
                                        <div class="d-flex align-items-center gap-2">
                                            <span class="material-symbols-outlined person-remove-icon">
                                                person_remove
                                            </span>
                                            <span class="remove">{{ $t('notification.remove') }}</span>
                                        </div>
                                    </div>
                                </div>
                                <div v-else>
                                    <span>{{ $t('notification.group.not_owner') }}</span>
                                </div>
                            </template>

                            <div v-if="user.id !== id" ref="actions_dropdown_user" class="ui right pointing suidropdown icon actions_user d-flex align-items-center">
                                <span class="material-symbols-outlined">
                                    more_vert
                                </span>
                                <div v-if="!showReportOptions" class="menu">
                                    <div class="item d-flex align-items-center gap-3" @click="addFriend(user.id)">
                                        <span class="material-symbols-outlined">
                                            person_add
                                        </span>
                                        {{ $i18n.t('notification.add_friend') }}
                                    </div>
                                    <div class="item d-flex align-items-center gap-3" @click="sendMessage(user.id)">
                                        <span class="material-symbols-outlined">
                                            forum
                                        </span>
                                        {{ $i18n.t('notification.send_message') }}
                                    </div>
                                    <div class="item d-flex align-items-center gap-3" @click.stop="openReportReasons(user.id)">
                                        <span class="material-symbols-outlined">
                                            flag
                                        </span>
                                        {{ $i18n.t('notification.report_user') }}
                                    </div>
                                    <div class="item d-flex align-items-center gap-3" @click="blockFriend(user.id)">
                                        <span class="material-symbols-outlined">
                                            block
                                        </span>
                                        {{ $i18n.t('notification.block_user') }}
                                    </div>
                                </div>

                                <div v-else class="menu">

                                    <div v-if="user.id === selectedUserId" class="ui form">
                                        <div class="inline field">
                                            <div class="ui radio checkbox">
                                                <input type="radio" tabindex="0" name="report_reason"
                                                       :id="$i18n.t('notification.inappropriate_language_or_content')"
                                                       :value="$i18n.t('notification.inappropriate_language_or_content')"
                                                       v-model="iptReportReason">
                                                <label>{{ $i18n.t('notification.inappropriate_language_or_content') }}</label>
                                            </div>
                                        </div>
                                        <div class="inline field">
                                            <div class="ui radio checkbox">
                                                <input type="radio" tabindex="0" name="report_reason"
                                                       :id="$i18n.t('notification.hate_messages_offensive')"
                                                       :value="$i18n.t('notification.hate_messages_offensive')"
                                                       v-model="iptReportReason">
                                                <label>{{ $i18n.t('notification.hate_messages_offensive') }}</label>
                                            </div>
                                        </div>
                                        <div class="inline field">
                                            <div class="ui radio checkbox">
                                                <input type="radio" tabindex="0" name="report_reason"
                                                       :id="$i18n.t('notification.spam')"
                                                       :value="$i18n.t('notification.spam')"
                                                       v-model="iptReportReason">
                                                <label>{{ $i18n.t('notification.spam') }}</label>
                                            </div>
                                        </div>
                                        <div class="inline field">
                                            <div class="ui radio checkbox">
                                                <input type="radio" tabindex="0" name="report_reason"
                                                       :id="$i18n.t('notification.fake_account')"
                                                       :value="$i18n.t('notification.fake_account')"
                                                       v-model="iptReportReason">
                                                <label>{{ $i18n.t('notification.fake_account') }}</label>
                                            </div>
                                        </div>
                                        <div class="inline field">
                                            <div class="ui radio checkbox">
                                                <input type="radio" tabindex="0" name="report_reason"
                                                       :id="$i18n.t('notification.other')"
                                                       :value="$i18n.t('notification.other')"
                                                       v-model="iptReportReason">
                                                <label>{{ $i18n.t('notification.other') }}</label>
                                            </div>
                                        </div>
                                        <div class="inline field">

                                            <input type="text"
                                                   maxlength="255"
                                                   :placeholder="$i18n.t('notification.other_reason')"
                                                   v-model="iptReportOtherReason"
                                                   :disabled="iptReportReason !== $i18n.t('notification.other')">

                                        </div>

                                        <div class="inline field">
                                            <div class="ui button send-button" @click="reportReason()">
                                                <span>{{ $i18n.t('notification.send') }}</span>
                                            </div>
                                        </div>

                                    </div>

                                </div>

                            </div>
                        </div>
                    </div>


                </div>

            </div>

        </div>

        <div class="ui suimodal tiny" id="exc-confirmation">
            <i class="close icon inside"></i>
            <!-- <div class="header">
                Modal Title
            </div> -->
            <div class="image content">
                <!-- <div class="image">
                An image can appear on left or an icon
                </div> -->
                <div class="description">
                {{ $i18n.t('notification.group.confirm_deletion_group') }}
                </div>
            </div>
            <div class="actions">
                <div class="ui button" data-type="0" @click="closeModalConfirmation">{{ $i18n.t('notification.group.no') }}</div>
                <div class="ui button" data-type="1" @click="closeModalConfirmation">{{ $i18n.t('notification.group.yes') }}</div>
            </div>
        </div>

    </div>
</template>

<script>

import { mapGetters} from "vuex";
import $ from 'jquery';

let emitter = require('tiny-emitter/instance');

export default {
    name: "DetailsEditGroup",
    props: {
        data: [],
    },
    watch: {
        data(newValue, oldValue) {
            console.log("DetailsEditGroup watch data: ", newValue, oldValue);
        }
    },
    data() {
        return {
            title: "",
            // thumb: 'https://api-local.virtual.town/storage/53/user_profile_picture/a812aa48b334986305a02df92ce293691730928779.png'
            thumb: '',
            searchUserTimeout: null,
            searchUserInput: '',
            listUsersFiltered: [],
            currentTab: 'group-info',
            isGroupOwner: false,
            listUsers: [],
            showReportOptions: false,
            iptReportReason: '',
            iptReportOtherReason: '',
            selectedUserId: 0
        }
    },
    beforeMount() {
        this.prepareUserList();
    },
    mounted() {
        console.log("DetailsEditGroup mounted: ", this.data, this.id);

        this.isGroupOwner = this.id === this.data.user_id;

        window.$(this.$refs.actions_dropdown).suidropdown({});
        this.initializeActionsDropdownUser();

    },
    methods: {
        groupDetails() {
            this.$parent.showView = "menu-create-group";
            console.log('group_id =>', this.data.id);

            emitter.emit('Chat::open::edit_group', { groupDetails: this.data});
        },
        userAtFirstPosition(users) {

            const userIndex = users.findIndex(user => user.id === this.id);

            const [user] = users.splice(userIndex, 1);
            users.unshift(user);

            return users;

        },
        initializeActionsDropdownUser() {
            const vm = this;
            // O nextTick é necessário para garantir que o elemento já foi renderizado
            vm.$nextTick(() => {
                window.$(vm.$refs.actions_dropdown_user).suidropdown({
                    onHidden: () => {
                        console.log("actions dropdown user onHidden");
                    },
                    onHide: () => {
                        console.log("actions dropdown user onHide");
                        vm.showReportOptions = false;
                        vm.initializeActionsDropdownUser();

                    }
                });
            });
        },
        sortAlphabeticcally(list) {
            return list.sort((a, b) => {
                return a.name.localeCompare(b.name);
            });
        },
        toggleUserSelection(user) {
            console.log("toggleUserSelection: ", user);

            // Atualiza a lista principal
            this.listUsers = this.listUsers.map(u =>
                u.id === user.id ? { ...u, selected: !u.selected } : u
            );

            // Atualiza a lista filtrada
            this.listUsersFiltered = [
                ...this.sortAlphabeticcally(this.listUsers.filter(user => user.selected)),
                ...this.sortAlphabeticcally(this.listUsers.filter(user => !user.selected)),
            ];

            console.log(this.listUsersFiltered);
        },
        getSelectedUsersCount() {
            return this.listUsers.filter(user => user.selected).length;
        },
        handleSearchUserInput(event) {
            console.log("handleSearchUserInput");
            let vm = this;

            clearTimeout(vm.searchUserTimeout);

            vm.searchUserTimeout = setTimeout(function() {

                let ok = false;
                if((event.type ==='input') && ((vm.searchUserInput.length >= 3) || (vm.searchUserInput.length === 0)))
                {
                    ok = true;
                }
                else if (event.type == 'click')
                {
                    ok = true
                }
                else
                {
                    ok = false;
                }

                if (ok)
                {
                    vm.listUsersFiltered = vm.listUsers.filter(user => {
                        return user.name.toLowerCase().includes(vm.searchUserInput.toLowerCase());
                    });
                }
                vm.initializeActionsDropdownUser();
            }, 700);

        },
        backButton() {
            console.log("backButton currentTab: ", this.currentTab);

            if(this.currentTab === 'add-members') {
                this.changeTab('group-info');
                return;
            }

            emitter.emit('MenuCreateGroup::backButton', { tab: 'tabInbox'});

        },
        exitGroup() {
            console.log("exitGroup");
            const vm = this;

            const payload = {
                group_id: vm.data.id
            }

            vm.$store.dispatch("Friends/exitGroup", payload)
                .then(() => {
                    vm.backButton();
                })
                .catch(error => {
                    console.log("error: ", error);
                });

        },
        closeModalConfirmation(e)
        {
            window.$('.ui.suimodal').suimodal('hide');
            if (e.currentTarget.dataset.type == '1')
            {
                const vm = this;
                const payload = {
                    group_id: vm.data.id
                }

                vm.$store.dispatch("Friends/deleteGroup", payload)
                    .then(() => {
                        vm.backButton();
                    })
                    .catch(error => {
                        console.log("error: ", error);
                    });
            }
            
        },
        deleteGroup() {
            console.log("deleteGroup");

            window.$('#exc-confirmation').suimodal({
                allowMultiple   : false,
                closable        : true,
                autofocus       : false,
                // context: document.getElementById('exc'),
                onApprove: () => {
                    // return false;
                },
                onDeny: () => {
                    // Implementar a lógica de cancelamento
                },
                onHidden: () => {
                    this.$emit('close');
                    // window.$('#exc-confirmation').remove();
                }
            }).suimodal('show');
            
        },
        changeTab(tab) {
            console.log("changeTab: ", tab);

            this.currentTab = tab;

            const element = document.querySelector(`[data-tab="${tab}"]`);

            // find all divs with data-tab
            const tabs = document.querySelectorAll('.tab');
            // remove active class from all tabs
            tabs.forEach(tab => tab.classList.remove('active'));
            // add active at element
            element.classList.add('active');

            if(tab === 'add-members') {
                this.title = this.$t('notification.group.add_members');
            } else if (tab == 'group-info') {
                this.title = '';
                console.log('### entrou aqui mesmo');
            }
        },
        openDescription() {
            $(".label-description-group .see-more").toggleClass('opened');
            $(".label-description-group .see-less").toggleClass('opened');
            $(".label-description-group .description").toggleClass('opened');
            $("#group-info").toggleClass('description-opened');
        },
        addFriend(userId) {

            this.$store.dispatch("Friends/AddFriend", { friend_id: userId })
                .then(() => {
                    console.log("addFriend success");
                    window.$.toast({
                        title: 'OK!',
                        message: this.$t('notification.group.send_success'),
                        class: 'success',
                        showIcon: 'check',
                        showProgress: 'top'
                    });
                })
                .catch(error => {
                    // console.log("addFriend error: ", error.response, " ||");
                    //juligo aqui adicionar feedback
                    let st = '';
                    for (let o in error.response.data.errors)
                    {
                        st += (error.response.data.errors[o] + '<br>');
                    }

                    window.$.toast({
                        title: 'Erro!',
                        message: st,
                        class: 'error',
                        showIcon: 'check',
                        showProgress: 'top'
                    });
                });
        },
        openReportReasons(userId) {
            console.log(`Reportando usuário: ${userId}`);
            this.selectedUserId = userId;
            this.showReportOptions = true; // Mostra o novo dropdown

            this.$nextTick(() => {
                window.$('.ui.radio.checkbox').checkbox();
            });

        },
        reportReason() {
            console.log(`Motivo do reporte: ${this.iptReportReason}`);

            const vm = this;

            if(this.iptReportReason === this.$i18n.t('notification.other') && this.iptReportOtherReason.length) {
                this.showReportOptions = false; // Oculta o dropdown após selecionar uma opção
            }

            let payload = {
                "id_user": this.selectedUserId,
                "reason": this.iptReportReason
            }

            if(this.iptReportReason === this.$i18n.t('notification.other') && this.iptReportOtherReason.length) {
                payload.reason = this.iptReportOtherReason;

            }

            this.$store.dispatch("Friends/reportUser", payload)
                .then(response => {
                    window.$.toast({
                        title: vm.$i18n.t('notification.sucesso'),
                        message: vm.$i18n.t('notification.user_reported'),
                        class: 'success',
                        showIcon: 'check',
                        showProgress: 'top'
                    });
                })
                .catch(error => {
                    console.log("reportReason error: ", error);
                    let st = '';
                    for (let o in error.response.data.errors)
                    {
                        st += (error.response.data.errors[o] + '<br>');
                    }

                    window.$.toast({
                        title: 'Erro!',
                        message: st,
                        class: 'error',
                        showIcon: 'check',
                        showProgress: 'top'
                    });
                })
                .finally(() => {
                    vm.showReportOptions = false;
                    vm.initializeActionsDropdownUser();
                });


        },
        blockFriend(userId) {

            const vm = this;
            
            this.$store.dispatch("Friends/BlockUser", { friend_id: userId })
                .then(() => {
                    console.log("addFriend success");

                    window.$.toast({
                        title: vm.$i18n.t('notification.sucesso'),
                        message: this.$t('notification.group.user_blocked'),
                        class: 'success',
                        showIcon: 'check',
                        showProgress: 'top'
                    });
                })
                .catch(error => {
                    console.log("addFriend error: ", error);

                    let st = '';
                    for (let o in error.response.data.errors)
                    {
                        st += (error.response.data.errors[o] + '<br>');
                    }

                    window.$.toast({
                        title: 'Erro!',
                        message: st,
                        class: 'error',
                        showIcon: 'check',
                        showProgress: 'top'
                    });
                });
        },
        prepareUserList() {
            this.listUsers = this.sortAlphabeticcally(this.data.users);
            this.listUsers = this.userAtFirstPosition(this.listUsers);

            this.listUsersFiltered = this.listUsers.map(user => user);
            console.log(this.listUsersFiltered);
        },
        seeAllGroupMembers() {
            console.log("seeAllGroupMembers");
            this.title = this.$t('notification.group_members');

            this.changeTab('all-group-users');
        },
        removeUserFromGroup(userId) {
            console.log("removeUserFromGroup", userId);

            const vm = this;
            const payload = {
                user_id: userId,
                group_id: this.data.id,
                event_id: this.data.event_id
            }



            this.$store.dispatch("Friends/removeUserFromGroup", payload)
                .then(() => {

                    // Retira da lista o usuário removido
                    vm.data.users = vm.data.users.filter(user => user.id !== userId);
                    vm.prepareUserList();
                })
                .catch(error => {
                    console.log("removeUserFromGroup error: ", error);
                });



        },
        sendMessage(userId) {

            const user = this.data.users.find(user => user.id === userId);

            let payload = {
                "title"         : user.name,
                "thumb"         : user.avatar,
                "isGroup"       : false,
                "recipientId"   : user.id
            };

            emitter.emit('MenuInbox::message::open', payload);


        }

    },
    computed: {
        ...mapGetters([
            'id'
        ])
    },
    beforeDestroy() {
    }
}
</script>
<style>
.ui.suimodals
{
    z-index: 1200 !important;
}
</style>
<style scoped lang="scss">

#menu-create-group {
    // max-height: 702px;
    // max-height: 100%;
    // overflow-y: auto;

    
    .header {

        .title {
            font-family: Open Sans, sans-serif;
            font-size: 20px;
            font-weight: 700;
            line-height: 27px;
            text-align: center;

        }

        .back-button {
            cursor: pointer;
        }

        .material-symbols-outlined {
            font-variation-settings:
                'FILL' 1,
                'wght' 400,
                'GRAD' 0,
                'opsz' 24
        }

        .hamburguer-menu {
            cursor: pointer;

            .menu {
            }

        }
    }

    #group-info {

        // height: 67vh;
        padding-right: 5px;
        margin-bottom: 30px;

        .upload-group-img {

            .group-image {
                position: relative;
                cursor: pointer;

                .thumb-icon {

                    width: 90px;
                    height: 90px;
                    background-color: #F1F1F1;
                    border-radius: 50%;

                }

                .landscape-icon {
                    color: #D8D8D8;
                }

                .upload {
                    width: 28px;
                    height: 28px;
                    background-color: #11BF03;
                    border-radius: 100px;
                    position: absolute;
                    top: 5px;
                    right: -5px;

                    .upload-icon {
                        font-size: 16px;
                        line-height: 24px;
                        color: #FFFFFF;
                    }

                }

                .thumb-container {


                    .thumb {
                        width: 90px;
                        height: 90px;

                        border-radius: 54px;
                        position: relative;
                        background-size: cover !important;
                        background-position: center !important;
                        background-repeat: no-repeat !important;
                        background-blend-mode: saturation;

                    }
                }
            }
        }

        .label-create-group {
            span {
                font-family: Open Sans, sans-serif;
                font-size: 20px;
                font-weight: 700;
                line-height: 27px;
                color: #393939;

            }
        }

        .label-description-group {

            .description {

                width: 80%;
                overflow: hidden;
                white-space: nowrap;
                &.opened {
                    width: 100%;
                    overflow: unset;
                    white-space: unset;
                }

            }

            span {
                font-family: Open Sans, sans-serif;
                font-size: 12px;
                font-weight: 400;
                line-height: 16px;
                color: #393939;
            }
            .see-more, .see-less {
                font-family: Open Sans, sans-serif;
                font-size: 12px;
                font-weight: 700;
                line-height: 16px;
                cursor: pointer;
                white-space: nowrap;
                color: #11BF03;

            }
            .see-more {
                display: flex;
                &.opened {
                    display: none;
                }
            }
            .see-less {
                display: none;
                &.opened {
                    display: inline;
                    margin-left: 13px;
                }
            }
        }



    }



    form.ui.form {

        label {
            font-family: Open Sans, sans-serif;
            font-size: 16px;
            font-weight: 600;
            line-height: 22px;
            color: #393939;
        }

        input, textarea {
            border-radius: 10px;
            font-family: Open Sans, sans-serif;
            font-size: 16px;
            font-weight: 400;
            line-height: 24px;
            color: #3939394D;
        }

    }

    .group-members {

        height: 100%;

        .users-count {
            padding-bottom: 20px;

            span {
                font-family: Open Sans, sans-serif;
                font-size: 18px;
                font-weight: 600;
                line-height: 24px;
            }

            .see-all-users {
                cursor: pointer;
                font-family: Open Sans, sans-serif;
                font-size: 14px;
                font-weight: 700;
                line-height: 19px;
                color: #11BF03;
            }
        }

        .search-add {

            margin: 15px 0;

            .ui.icon.input {
                position: relative;
                input {
                    border-radius: 10px;
                }

                .search-icon {
                    cursor: pointer;
                    position: absolute;
                    width: 16px;
                    height: 16px;
                    color: var(--buttons_color);
                    right: 25px;
                    top: 22.5%;
                }
            }
        }

        .list-users {

            height: 100%;

            .remove-group {
                border: 1px solid var(--buttons_color);
                border-radius: 10px;
                color: var(--buttons_color);

                .person-remove-icon {
                    font-family: "Material Icons";
                    font-size: 20px;
                    font-weight: 400;
                    line-height: 24px;
                }

                .remove {
                    font-family: Exo, sans-serif;
                    font-size: 14px;
                    font-weight: 600;
                    line-height: 19px;

                }

                &:active {
                    background-color: var(--buttons_color);
                    color: #FFFFFF;
                }
            }

            .search-icon {
                color: #B1B1B1;
                font-weight: 400;
                font-size: 32px;
                line-height: 24px;


                font-variation-settings:
                    'FILL' 1,
                    'wght' 400,
                    'GRAD' 0,
                    'opsz' 24
            }


            .actions_user {

                .menu {

                    border-radius: 10px;

                    .item {

                        font-family: Open Sans, sans-serif;
                        font-size: 14px;
                        font-weight: 400;
                        // line-height: 22px;
                        color: #393939;

                        .material-symbols-outlined {
                            font-family: 'Material Icons';
                            font-size: 18px;
                            font-weight: 400;
                            // line-height: 20px;
                            color: #393939;

                            font-variation-settings:
                                'FILL' 1,
                                'wght' 400,
                                'GRAD' 0,
                                'opsz' 24;
                        }


                        &:first-of-type:hover {
                            border-radius: 10px 10px 0 0;
                        }
                        &:last-of-type:hover {
                            border-radius: 0 0 10px 10px;
                        }

                    }

                    .inline.field {
                        position: relative;
                        cursor: pointer;
                        border: none;
                        height: auto;
                        min-height: 36px;
                        text-align: left;
                        color: rgba(0, 0, 0, .87);
                        padding: 5px 10px;
                        text-transform: none;
                        font-weight: 400;
                        box-shadow: none;

                        .send-button {
                            color: var(--buttons_color);
                            font-family: Open Sans, sans-serif;
                            font-size: 16px;
                            border-radius: 10px;

                        }

                    }

                }



            }

            .thumb {
                width: 42px;
                height: 43px;
                border-radius: 54px;
                position: relative;
                background-size: cover !important;
                background-position: center !important;
                background-repeat: no-repeat !important;
                background-blend-mode: saturation;

            }

            overflow-y: scroll; /* ou auto para adicionar rolagem apenas quando necessário */
            -ms-overflow-style: none; /* Para ocultar no Internet Explorer e Edge */
            scrollbar-width: none; /* Para ocultar no Firefox */

            &::-webkit-scrollbar {
                display: none; /* Para ocultar no Chrome, Safari e Opera */
            }

            .d-none {
                display: none !important;
            }

            .ui.suidropdown .menu>.item:hover {
                background-color: var(--buttons_color);
            }

        }



    }

    .footer {

        margin-top: auto;

        .btn-actions {

            .btn-delete-group, .btn-exit-group {
                cursor: pointer;
            }
            span {
                font-family: Open Sans, sans-serif;
                font-size: 16px;
                font-weight: 400;
                line-height: 22px;
                color: #D70000;
            }

            .material-symbols-outlined {
                font-family: 'Material Icons';
                font-size: 20px;
                font-weight: 400;
                line-height: 20px;
                color: #D70000;

                font-variation-settings:
                    'FILL' 1,
                    'wght' 400,
                    'GRAD' 0,
                    'opsz' 24;
            }

        }
    }



    .tab {
        display: none;

        &.active {
            display: block;
        }

    }

    #add-members {

        height: 500px;

        .search-add {

            .ui.icon.input {
                position: relative;
                input {
                    border-radius: 10px;
                }

                .search-icon {
                    position: absolute;
                    width: 16px;
                    height: 16px;
                    color: var(--buttons_color);
                    right: 25px;
                    top: 22.5%;
                }
            }
        }

        .list-users {

            height: 100%;

            .search-icon {
                color: #B1B1B1;
                font-weight: 400;
                font-size: 32px;
                line-height: 24px;


                font-variation-settings:
                    'FILL' 1,
                    'wght' 400,
                    'GRAD' 0,
                    'opsz' 24
            }
            .no-results {
                font-family: Open Sans, sans-serif;
                font-size: 16px;
                font-weight: 600;
                line-height: 24px;
                color: #696A70;
            }
            .no-user-found {
                font-family: Open Sans, sans-serif;
                font-size: 16px;
                font-weight: 400;
                line-height: 24px;
                color: #696A70;
            }

            .add-user, .remove-user {

                border: 1px solid var(--buttons_color);
                border-radius: 10px;
                padding: 11px 14px;

                .label {
                    font-family: Exo, sans-serif;
                    font-size: 14px;
                    font-weight: 600;
                    line-height: 19px;
                }

            }

            .add-user {
                background-color: var(--buttons_color);
                color: #FFFFFF;

                .person-add-icon {
                    font-family: 'Material Icons';
                    font-size: 20px;
                    font-weight: 400;
                    line-height: 24px;
                    color: #FFFFFF;

                    font-variation-settings:
                        'FILL' 1,
                        'wght' 400,
                        'GRAD' 0,
                        'opsz' 24
                }
            }

            .remove-user {

                color: var(--buttons_color);

                .person-remove-icon {
                    font-family: 'Material Icons';
                    font-size: 20px;
                    font-weight: 400;
                    line-height: 24px;

                    font-variation-settings:
                        'FILL' 1,
                        'wght' 400,
                        'GRAD' 0,
                        'opsz' 24
                }
            }

            .thumb {
                width: 42px;
                height: 43px;
                border-radius: 54px;
                position: relative;
                background-size: cover !important;
                background-position: center !important;
                background-repeat: no-repeat !important;
                background-blend-mode: saturation;

            }

            overflow-y: scroll; /* ou auto para adicionar rolagem apenas quando necessário */
            -ms-overflow-style: none; /* Para ocultar no Internet Explorer e Edge */
            scrollbar-width: none; /* Para ocultar no Firefox */

            &::-webkit-scrollbar {
                display: none; /* Para ocultar no Chrome, Safari e Opera */
            }

        }

        .save-members {

            .btn-save {
                width: 164px;
                height: 43px;
                background-color: var(--buttons_color);
                color: #FFFFFF;
                padding: 11px 14px;
                border-radius: 10px;

            }

        }

    }

    #all-group-users {
        height: 615px;
    }

    .py-32 {
        padding-top: 32px !important;
        padding-bottom: 32px !important;
    }

    .py-24 {
        padding-top: 15px !important;
        padding-bottom: 15px !important;
    }

    #group-info{
        .ui.suidropdown .menu>.item{
            padding: 5px 10px !important;
            min-height: auto !important;
        }
    }

}

</style>